// @flow
import { compose } from 'redux'
// $FlowFixMe TypeScript import
import Login from '../src/login/Login'
import withAuthentication from '../src/withAuthentication'
import { HOME, permissions } from '../src/routes'

export default compose(withAuthentication(permissions[HOME]))(Login)
